import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { URLS } from 'src/app/constants/URLS';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css']
})
export class DeleteModalComponent implements OnInit {
  screenName:string = '';
  profileImage:string = '';

  constructor(
    public dialogRef: MatDialogRef<DeleteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { screenname: string, profileImage: string, delete:boolean },
    ) {
      console.log(data)
      this.screenName = data.screenname
      this.profileImage = data.profileImage
  }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: this.data });
  }

  removeData() {
    console.log(this.data);
    this.data.delete = true;
    this.closeDialog();
  }

  noThanks() {
    console.log(this.data);
    this.data.delete = false;
    this.closeDialog();
  }
}
